var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[_c('div',{ref:"playerContainer",staticClass:"player",attrs:{"id":"videoContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }